/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AuditLogsAccessResponse } from '../models/AuditLogsAccessResponse';
import type { ExportAuditLogsRequest } from '../models/ExportAuditLogsRequest';
import type { GetAuditLogsResponse } from '../models/GetAuditLogsResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuditLogsService {
  /**
   * @param pageNumber A page number within the paginated result set.
   * @param pageSize Number of results to return per page.
   * @param domainArea
   * @param rootEntityId
   * @param rootEntityType
   * @param companyMeasurementDateId
   * @param company
   * @param firm
   * @param fund
   * @param startDate Filter logs created on or after this datetime. Format ISO_8601
   * @param endDate Filter logs created on or before this datetime. Format: ISO_8601
   * @param user Integer representing user responsible for the change
   * @param product
   * @returns GetAuditLogsResponse
   * @throws ApiError
   */
  public static apiAuditLogsList(
    pageNumber?: number,
    pageSize?: number,
    domainArea?: 'allocations' | 'valuations' | 'financials' | 'documents' | 'companies' | 'cap_table' | 'fulfillments' | 'funds' | 'firms' | 'fund_ownership',
    rootEntityId?: number,
    rootEntityType?: 'allocation' | 'valuation' | 'financial_statement' | 'measurement_date_documents' | 'company' | 'cap_table' | 'fund_ownership' | 'fulfillment' | 'fund',
    companyMeasurementDateId?: number,
    company?: number,
    firm?: number,
    fund?: number,
    startDate?: string,
    endDate?: string,
    user?: number,
    product?: 'portfolio-valuations' | 'workboard' | 'all',
  ): CancelablePromise<GetAuditLogsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/audit-logs',
      query: {
        'page_number': pageNumber,
        'page_size': pageSize,
        'domain_area': domainArea,
        'root_entity_id': rootEntityId,
        'root_entity_type': rootEntityType,
        'company_measurement_date_id': companyMeasurementDateId,
        'company': company,
        'firm': firm,
        'fund': fund,
        'start_date': startDate,
        'end_date': endDate,
        'user': user,
        'product': product,
      },
    });
  }
  /**
   * Get user's access scope for audit logs
   * Returns the scope of audit logs that the user has access to, including standalone companies and firms with their respective funds and companies.
   * @returns AuditLogsAccessResponse
   * @throws ApiError
   */
  public static apiAuditLogsAccessRead(): CancelablePromise<AuditLogsAccessResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/audit-logs/access',
      errors: {
        403: `Forbidden - The user does not have permission to access audit logs`,
      },
    });
  }
  /**
   * Export audit logs as Excel workbook
   * Exports audit logs as an Excel workbook. Columns contained are similar to the columns displayed in the audit logs list view.
   * @param data
   * @returns binary Audit logs Excel workbook
   * @throws ApiError
   */
  public static apiAuditLogsExportCreate(
    data: ExportAuditLogsRequest,
  ): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/audit-logs/export',
      body: data,
      errors: {
        404: `No audit logs found for the requested criteria.`,
        500: `Unable to export audit logs.`,
      },
    });
  }
}
